 


    <div class="container loginBg">
        <div class="login">
            <div class="boxMain"> 
                    <p class="titleP">Bienvenido a</p>
                    <img src="../../../assets/img/logo-claro-qr.svg" alt="" class="logoLogin">
                    
                        <input type="text" placeholder="Usuario"  [(ngModel)]="usuario" class="user">
                        <input type="password" placeholder="Contraseña" [(ngModel)]="password"  class="pass">
                        <input type="checkbox" [(ngModel)]="recordarme">
                        <label for="" class="recordarme">Recordarme</label>
                        <p>
                            <input type="submit" value="Ingresar" class="ingresar" (click)="ingresar()">
                        </p>
                        
                    
            </div>
            
        </div>
        <div class="loginBox">
            <p class="titleMain">Generador de códigos QR's</p>
            <img src="../../../assets/img/qr-mano.png" alt="" class="qr-mano">
            <img src="../../../assets/img/qr.svg" alt="" class="qr">
        </div>
        
    </div>
    <footer class="footer">
        Todos los derechos reservados, Claro 2024
    </footer>
    <app-loading *ngIf="loading$ | async"></app-loading>
    <!-- Tu contenido de la aplicación aquí -->
    